// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    filterStations,
    loadStations,
    showDeleteStationPrompt,
    deletePromptReset,
    removeStation,
} from '../../redux/reducers/stations';
import List from '../../components/Stations/List';
import Filter from '../../components/shared/Filter';

import Loader from '../../components/Loader/Loader';
import DeleteStationModal from '../../components/Stations/DeleteModal';
import Pagination from '../../components/shared/Pagination';

import { colors } from '../../shared/styles';

const StationsWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }
`;

class Stations extends Component {
    onFilterChange: Function;
    onFilterReset: Function;
    onFilterSubmit: Function;
    onPageChange: Function;
    onDelete: Function;
    confirmDelete: Function;
    deletePromptReset: Function;
    refresh: Function;

    state = {
        refreshing: false,
    };

    constructor(props) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
        this.onFilterReset = this.onFilterReset.bind(this);
        this.onFilterSubmit = this.onFilterSubmit.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadStations(1));
    }

    onFilterChange(e) {
        this.props.dispatch(filterStations(e.target.value));
    }

    onFilterReset() {
        this.props.dispatch(filterStations(''));

        this.props.dispatch(loadStations(1));
    }

    onFilterSubmit(e) {
        e.preventDefault();

        this.props.dispatch(loadStations(1));
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadStations(pageNo));
    }

    onDelete(station) {
        this.props.dispatch(
            showDeleteStationPrompt(station.stationId, station.stationName)
        );
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { stationId, stationName },
        } = this.props;

        dispatch(removeStation(stationId, stationName)).then(() => {
            this.refresh();
        });
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    refresh() {
        this.setState({
            refreshing: true,
        });

        setTimeout(() => {
            this.props.dispatch(loadStations(1));
            this.setState({
                refreshing: false,
            });
        }, 500);
    }

    render() {
        const {
            stations,
            filter,
            isFetching,
            deletePrompt,
            pagination,
            total,
            fetchingTime,
        } = this.props;
        const { refreshing } = this.state;

        return (
            <StationsWrapper>
                <DeleteStationModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    stationName={deletePrompt.stationName}
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                />
                <Filter
                    filter={filter}
                    onFilterChange={this.onFilterChange}
                    onFilterReset={this.onFilterReset}
                    onFilterSubmit={this.onFilterSubmit}
                    total={total}
                    fetchingTime={fetchingTime}
                    suffix={'Station'}
                />
                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !stations) &&
                            <Loader message="Loading stations, please wait..." />}
                        {refreshing &&
                            <Loader message="Refreshing, please wait..." />}
                        {!isFetching &&
                            stations &&
                            !refreshing &&
                            <List
                                stations={stations}
                                onDelete={this.onDelete}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </StationsWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.stations.list;
    const remove = state.stations.remove;

    return {
        errorFetching: list.error,
        filter: list.filter,
        isFetching: list.fetching,
        stations: list.stations,
        deletePrompt: {
            stationId: remove.stationId,
            stationName: remove.stationName,
            removing: remove.removing,
            visible: Boolean(remove.stationId && remove.stationName),
        },
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
    };
};

export default connect(mapStateToProps)(Stations);



// WEBPACK FOOTER //
// ./src/containers/Stations/Stations.js